// Libs
import React, { useContext } from "react";

// Utils
import type { SortDirection } from "src/design-system/molecules/tables";
import type { TableConfiguration } from "./types";

export interface TableContextType<DT = Record<string, unknown>, FT = DT> {
    activeGroups: string[];
    conf: TableConfiguration<DT, FT>;
    extraProps?: Record<string, unknown>;
    handleGroupToggle?: (groupKey: string) => void;
    handleColumnSortToggle?: (columnKey: string) => void;
    lastSortKey: string;
    sorts: {
        key: string;
        direction: SortDirection;
        customOrderMapConverter?: Record<string, number>;
    }[];
}

const TableContext = React.createContext<TableContextType>(null);

export function useTableContext(): TableContextType {
    return useContext(TableContext);
}

export function TableContextProvider<DT, FT>({
    children,
    ...otherProps
}: React.PropsWithChildren<TableContextType<DT, FT>>): JSX.Element {
    return <TableContext.Provider value={otherProps as any}>{children}</TableContext.Provider>;
}
